import React, { useEffect, useState } from 'react';

interface ArbitrageProfitDisplayProps {
    profit: string | null;
    direction: 'up' | 'down' | 'none';
}

const ArbitrageProfitDisplay: React.FC<ArbitrageProfitDisplayProps> = ({ profit, direction }) => {
    // State to manage the temporary color flash
    const [flashColor, setFlashColor] = useState<'up' | 'down' | null>(null);

    // This effect runs every time the profit value changes
    useEffect(() => {
        // Don't flash if there's no direction change
        if (direction === 'none') return;

        // 1. Set the flash color based on the direction
        setFlashColor(direction);

        // 2. Set a timer to remove the flash color after 1.2 seconds
        const timer = setTimeout(() => {
            setFlashColor(null);
        }, 1200);

        // 3. Cleanup: clear the timer if the component unmounts or if profit changes again
        return () => clearTimeout(timer);
    }, [profit, direction]); // Effect depends on both profit and direction

    // Determine color classes for the profit text based on the temporary flash state
    const textFlashClass =
        flashColor === 'up'
            ? 'text-emerald-600 dark:text-emerald-400'
            : flashColor === 'down'
              ? 'text-red-600 dark:text-red-400'
              : ''; // Default color (inherits from parent)

    return (
        <div className='my-2 flex items-center justify-center gap-2 text-xs'>
            <span>سود آربیتراژ تتر بدون کارمزد:</span>
            <span className={`font-bold ${textFlashClass}`}>{profit ? `${profit}%` : '-'}</span>
            <span className='relative flex size-2'>
                <span className='absolute inline-flex size-full animate-ping rounded-full bg-green-500 opacity-75'></span>
                <span className='relative inline-flex size-2 rounded-full bg-green-600'></span>
            </span>
        </div>
    );
};

export default ArbitrageProfitDisplay;
